import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useIntl } from "../../../../../shared/core/i18n/use-intl";
import { circleSuccessIcon } from "../../../../assets/images";
import { Path } from "../../../../core/routing/path";
import { PrimaryButton } from "../../../common/buttons/primary-button";
import { MarkdownText } from "../../../common/forms/markdown-text";
import { theme } from "../../../styles/theme";
import EnrollmentLayout from "../shared/components/enrollment-layout";

const OnboardingRedirectScreen = () => {
  const { formatMessage } = useIntl();
  const { push } = useHistory();

  return (
    <EnrollmentLayout centered>
      <SuccessLogoImage src={circleSuccessIcon} alt="onboarding-success" />
      <Title>{formatMessage("onboardingScreen.submissionThanks")}</Title>
      <Subtitle>{formatMessage("onboardingScreen.identityVerificationDescription")}</Subtitle>
      <PrimaryButton size="S" onClick={() => push(Path.Root)}>
        {formatMessage("onboardingScreen.successButton")}
      </PrimaryButton>
    </EnrollmentLayout>
  );
};

export default OnboardingRedirectScreen;

const SuccessLogoImage = styled.img`
  align-self: center;
  width: 200px;
  height: 200px;
`;

const Title = styled(MarkdownText)`
  ${theme.boldText};
  font-size: 1.2rem;
  line-height: 2.875rem;
  margin-bottom: 10px;
`;

const Subtitle = styled(MarkdownText)`
  color: ${theme.colors.gray[500]};
  text-align: center;
  margin-bottom: 24px;
`;
